import { type PropsWithChildren } from 'react';

export const RootLayout = ({ children }: PropsWithChildren) => {
	return (
		<>
			<div className="fixed inset-0">
				<div className="h-full w-full bg-[#f8f8f8]" />
			</div>
			<div className="relative z-10">{children}</div>
		</>
	);
};
